import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Font } from '@react-pdf/renderer';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Register fonts for PDF generation - do this once at app startup
// Prevent re-registration during HMR in development
if (!(window as any).__PDF_FONTS_REGISTERED__) {
  Font.register({
    family: 'Helvetica'
    // No fonts array needed for Helvetica as it's built-in
  });
  (window as any).__PDF_FONTS_REGISTERED__ = true;
}

// Register service worker for PWA
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New content available. Reload to update?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);